/**Модель для описания видеозаписи */
export class VideoModel {
  /**Ссылка */
  Link?: string
  /**Имя */
  Name?: string
  /**Автопроигрывание */
  AutoPlay?: boolean

  constructor(obj?: Partial<VideoModel>) {
    if (obj) Object.assign(this, obj)
  }
}
